import {
  BOARD_END_HOUR,
  BOARD_START_HOUR,
  HOUR_WIDTH,
  shiftHourFromIso,
} from '../../../shared/lib/schedule';

interface Props {
  /** The technician works this day at all. A non-working day greys out the whole track. */
  working: boolean;
  shiftStart: string | null;
  shiftEnd: string | null;
}

/** Grey shading over the hours a technician is not on shift. */
export const BoardShiftOverlay = ({ working, shiftStart, shiftEnd }: Props) => {
  if (!working) return <div className="absolute inset-0 bg-gray-300/50" aria-hidden />;

  const shiftStartHour = shiftStart ? shiftHourFromIso(shiftStart) : null;
  const shiftEndHour = shiftEnd ? shiftHourFromIso(shiftEnd) : null;

  const preShiftWidth =
    shiftStartHour != null && shiftStartHour > BOARD_START_HOUR
      ? (Math.min(shiftStartHour, BOARD_END_HOUR) - BOARD_START_HOUR) * HOUR_WIDTH
      : 0;

  const postShiftWidth =
    shiftEndHour != null && shiftEndHour < BOARD_END_HOUR
      ? (BOARD_END_HOUR - Math.max(shiftEndHour, BOARD_START_HOUR)) * HOUR_WIDTH
      : 0;

  return (
    <>
      {preShiftWidth > 0 && (
        <div
          className="absolute bottom-0 left-0 top-0 bg-gray-300/50"
          style={{ width: preShiftWidth }}
          aria-hidden
        />
      )}
      {postShiftWidth > 0 && (
        <div
          className="absolute bottom-0 right-0 top-0 bg-gray-300/50"
          style={{ width: postShiftWidth }}
          aria-hidden
        />
      )}
    </>
  );
};
